// @flow

import styled from "styled-components";

import { Flex } from "@src/common";
import spacingExtender from "@src/common/spacingExtender";
import { fullColorExtender } from "@src/common/colors";

const Content = styled(Flex)`
  flex-direction: column;
  height: calc(100vh - 100px);
  position: relative;
  justifyContent: flex-start;
  alignItems: flex-start;
  ${() => spacingExtender({ paddingH: "3", marginV: "4" })};
`;

const ContentBody = styled.div`
  overflow-y: auto;
  margin-bottom: 62px;
  width: 100%;
  flex-basis: calc(100vh - 260px);
  min-height: calc(100vh - 260px);
  ${spacingExtender}
`;

const ContentLayout = styled(Flex)`
  overflow: hidden;
  min-height: calc(100vh - 160px);
  border-radius: 5px;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  position: relative;
  ${() => fullColorExtender({ backgroundColor: "white" })};
`;

const ContentHeader = styled(Flex)`
  flex: none;
  justify-content: flex-start;
  ${() => spacingExtender({ paddingV: "2", paddingH: "4" })};
`;

const UL = styled.ul`
  ${() => spacingExtender({ marginV: "0", marginH: "3" })};
  padding: 0;
  width: 100%;
`;

const LI = styled.li`
  ${() => spacingExtender({ marginV: "2" })};
`;

export { Content, ContentBody, ContentLayout, ContentHeader, LI, UL };



// WEBPACK FOOTER //
// ./src/components/index.js